// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var grid = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.gridTemplateRows(["auto"]),
      BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.justifyItems("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height("auto")
          ]),
      BsCssJs$PrezzeeRibbon.selector("&>*", [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.alignItems("center"),
            BsCssJs$PrezzeeRibbon.justifyContent("center")
          ])
    ]);

var Styles = {
  grid: grid
};

function perRow(pr) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              {
                                NAME: "num",
                                VAL: pr
                              },
                              "auto"
                            ]
                          }])])]);
}

function perRowTablet(pr) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              {
                                NAME: "num",
                                VAL: pr
                              },
                              "auto"
                            ]
                          }])])]);
}

function perRowMobile(pr) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              {
                                NAME: "num",
                                VAL: pr
                              },
                              "auto"
                            ]
                          }])])]);
}

function gapStyle(gap) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(gap))])]);
}

function gapStyleTablet(gap) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(gap))])]);
}

function gapStyleMobile(gap) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.gridGap(BsCssJs$PrezzeeRibbon.px(gap))])]);
}

var StyleGen = {
  perRow: perRow,
  perRowTablet: perRowTablet,
  perRowMobile: perRowMobile,
  gapStyle: gapStyle,
  gapStyleTablet: gapStyleTablet,
  gapStyleMobile: gapStyleMobile
};

function ImageGrid(props) {
  var perRowMobile$1 = props.perRowMobile;
  var perRowTablet$1 = props.perRowTablet;
  var perRow$1 = props.perRow;
  var gapMobile = props.gapMobile;
  var gapTablet = props.gapTablet;
  var gap = props.gap;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var gap$1 = gap !== undefined ? gap : 0;
  var gapTablet$1 = gapTablet !== undefined ? gapTablet : 0;
  var gapMobile$1 = gapMobile !== undefined ? gapMobile : 0;
  var perRow$2 = perRow$1 !== undefined ? perRow$1 : 6;
  var perRowTablet$2 = perRowTablet$1 !== undefined ? perRowTablet$1 : 6;
  var perRowMobile$2 = perRowMobile$1 !== undefined ? perRowMobile$1 : 2;
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    grid,
                    gapStyle(gap$1),
                    gapStyleTablet(gapTablet$1),
                    gapStyleMobile(gapMobile$1),
                    perRow(perRow$2),
                    perRowTablet(perRowTablet$2),
                    perRowMobile(perRowMobile$2),
                    className$1
                  ])
            });
}

var make = ImageGrid;

export {
  Styles ,
  StyleGen ,
  make ,
}
/* grid Not a pure module */
